export function applyDisplayName(component, displayName) {
    component.displayName = displayName;
}
//# sourceMappingURL=apply-display-name.js.map